// import { Navigate } from "react-router-dom";
// import { useAuth } from "../context/AuthContext";

// export default function ProtectedRoute({ children }) {
//   const { user } = useAuth();

//   if (!user) {
//     return <Navigate to="/" />;
//   }

//   return children;
// }

// import { Navigate } from "react-router-dom";
// import { useAuth } from "../context/AuthContext";
// import { getGymByUserId } from "../services/gymService";
// import { useEffect, useState } from "react";

// export default function ProtectedRoute({ children }) {
//   const { user } = useAuth();
//   const [gym, setGym] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const loadGym = async () => {
//       if (!user) {
//         setLoading(false);
//         return;
//       }

//       const data = await getGymByUserId(user.uid);
//       setGym(data);
//       setLoading(false);
//     };

//     loadGym();
//   }, [user]);

//   if (!user) {
//     return <Navigate to="/login" replace />;
//   }

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   if (
//     gym?.registrationType === "paid" &&
//     gym?.subscriptionStatus !== "Active"
//   ) {
//     return <Navigate to="/subscription" replace />;
//   }

//   return children;
// }

import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getGymByUserId } from "../services/gymService";
import { useEffect, useState } from "react";

export default function ProtectedRoute({ children }) {
  const { currentUser, loading: authLoading } = useAuth();

  const [gym, setGym] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadGym = async () => {
      if (!currentUser) {
        setLoading(false);
        return;
      }

      try {
        const data = await getGymByUserId(currentUser.uid);
        setGym(data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    loadGym();
  }, [currentUser]);

  if (authLoading || loading) {
    return <div>Loading...</div>;
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (
    gym?.registrationType === "paid" &&
    gym?.subscriptionStatus !== "Active"
  ) {
    return <Navigate to="/subscription" replace />;
  }

  return children;
}
